import React, { useContext } from 'react'
import { Row, Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import ContactForm from './ContactForm'
import Container from './Container'
import { BodyCopy, H2 } from './Typography'
import media from 'css-in-js-media'
import { Variables } from '../styles/Variables'
import { StyledButton } from './Button'
import { useContactForm } from '../hooks/ContactForm'
import LayoutContext from './LayoutContext'

const ContactSection = styled.div`
    height: 100%;
    padding: 124px 20px;
    background-color: ${Variables.color.cocoa};

    ${media('<desktop')} {
        padding: 56px 20px;
    }

    ${Container} {
        padding: 0;
        margin: 0 auto;
        max-width: 900px;
    }

    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
    }

    ${H2} {
        text-transform: uppercase;
    }
`

const ContactformWrap = styled.div`
    ${StyledButton} {
        color: ${Variables.color.white};
        font-size: 14px;
        ${media('<desktop')} {
            font-size: 12px;
        }
        ${media('>=desktop')} {
            max-width: 240px;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
`

const StyledContactTitleCol = styled(Col)`
    text-align: center;
    ${H2} {
        color: ${Variables.color.white};
        margin-bottom: 20px;
        ${media('<desktop')} {
            max-width: 181px;
            margin: 0 auto;
            margin-bottom: 20px;
            font-size: 28px;
        }
    }
    ${BodyCopy} {
        font-family: ${Variables.font.body};
        color: ${Variables.color.white};
        font-size: 20px;
        line-height: 120%;
        margin-bottom: 20px;

        p {
            white-space: pre-line;
        }
        ${media('<desktop')} {
            font-size: 16px;
        }
    }
`

const ContactFormSection = () => {
    const dataForm = useContactForm()
    const { currentLang } = useContext(LayoutContext)
    const formdata = dataForm.edges.find(
        (i) => i.node.node_locale == currentLang.langKey
    ).node

    return (
        <ContactSection id="contactForm">
            <Container>
                <Row>
                    <StyledContactTitleCol xs={12}>
                        <H2>{formdata.formTitle}</H2>
                        {formdata.formCopy && (
                            <BodyCopy
                                dangerouslySetInnerHTML={{
                                    __html:
                                        formdata.formCopy.childMarkdownRemark
                                            .html,
                                }}
                            />
                        )}
                    </StyledContactTitleCol>
                    <Col xs={12}>
                        <ContactformWrap>
                            <ContactForm layout="2" darktheme />
                        </ContactformWrap>
                    </Col>
                </Row>
            </Container>
        </ContactSection>
    )
}

export default ContactFormSection
